<template>
  <div class="reward-pli-container">
    <div class="product-line-item-container">
      <div class="pli-first-container">
        <img
          class="pli-image"
          src="https://www.fresh.com/dw/image/v2/BDJQ_PRD/on/demandware.static/-/Sites-fresh_master_catalog/default/dw1c68f1e4/Products/EngravingIcon_1000x1000.jpg?sw=160&amp;sh=160&amp;bgcolor=F7F7F8&amp;sfrm=jpg"
          alt="Custom Engraving"
          title="Custom Engraving"
        />
      </div>

      <div class="pli-second-container">
        <div class="pli-product-details-and-price">
          <div class="pli-product-details">
            <div class="pli-product-name">
              <span v-html="$t('label.custom.engraving')"></span>
            </div>
            <div class="pli-product-attributes font-weight-light">
              <span v-html="$t('field.engravedtext')"></span> :
                <svg v-if="product.engravedEmoji" class="engraved-emoji">
                  <use :href="`${svgPath}#${product.engravedEmoji}`" />
                </svg>
              {{ product.engravedText }}
            </div>
          </div>
          <div class="pli-price-container-wrapper">
            <div class="pli-product-price-container">
              <div
                :class="[
                  'pli-product-price',
                  product.isSample ? 'invisible' : '',
                ]"
              >
                <span> <span v-html="freePrice"></span> </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";
export default {
  name: "ProductEngraving",
  components: {},
  setup() {
    const { vueVariables } = vue3_mapGetters();
    return {
        vueVariables
    }
  },
  data() {
    return {
      freePrice: this.vueVariables.freePrice,
    };
  },
  methods: {
  },
  computed: {
    ...mapState(["svgPath", "actionURLs"]),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  created() {},
};
</script>

<style >
</style>
